const REGISTERED_ACCOUNT_TYPES = [
  'TFSA',
  'RRSP',
  'RESP',
  'LIRA',
  'LIF',
  'RRIF',
  'RDSP',
  'FHSA',
  'DPSP',
];

export const isRegisteredAccountType = (
  accountType?: string | null,
): boolean => {
  if (!accountType) {
    return false;
  }

  const normalized = accountType.toUpperCase();
  return REGISTERED_ACCOUNT_TYPES.some((registeredType) =>
    normalized.includes(registeredType),
  );
};
